import { render, staticRenderFns } from "./PersonalContactoEmergencia.vue?vue&type=template&id=3afbfd74"
import script from "./PersonalContactoEmergencia.vue?vue&type=script&lang=js"
export * from "./PersonalContactoEmergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports